import React, { useMemo } from 'react';
import { useAttentionState, AttentionContextProvider } from 'context/AttentionContext';
import classNames from 'classnames';

export default function withAttention(Component) {
    function withAttentionProvider(Component) {
        function WithAttentionProvider(props) {
            return (
                <AttentionContextProvider>
                    {useMemo(() => { return <Component {...props} /> }, [props])}
                </AttentionContextProvider>
            )
        }

        return WithAttentionProvider;
    }

    function WithAttention({additionalClassNames, ...props}) {
        const { attentionState } = useAttentionState();

        const classes = classNames(additionalClassNames, {
            [`${attentionState}`]: attentionState
        });

        return (
            <Component {...props} additionalClassNames={classes} />
        );
    }

    return withAttentionProvider(WithAttention);
}